
import AdminTransact from "../components/admin/AdminInvoice";

export default function AdminInvoice() {
  return (
    <div>
      <AdminTransact />
    </div>
  );
}
